import Utils from 'src/utils';
import store from 'src/store';
import { selectEmployeesContractType } from 'src/store/selectors/employees';
import dayjs from 'dayjs';
import { compose, map } from 'ramda';
import { MOMENT_MAX_DATE } from 'src/constants/dayjs';
export const multipleEmployeesContractsToListMap = (contracts) => {
    const userIdsWithContracts = {};
    contracts.forEach((contract) => {
        userIdsWithContracts[contract.UserId] = ({
            ...(userIdsWithContracts[contract.UserId] || {}),
            [contract.Id]: parseContract(Utils.objects.decapitalizeObjectKeysRecursively(contract))
        });
    });
    return userIdsWithContracts;
};
export const parseContract = ({ id, contractTypeId, ...props }) => ({
    ...props,
    id: id.toString(),
    contractTypeId: contractTypeId.toString()
});
export const employeeContractsToListMap = (contracts) => compose(Utils.objects.normalizeList('id'), map(parseContract), map(Utils.objects.decapitalizeObjectKeysRecursively))(contracts);
export function getActiveContract(contracts, isDecapitalized = false, onDate = dayjs()) {
    const getEndDate = (contract) => (isDecapitalized ? contract.period?.endDate : contract.Period?.EndDate);
    const getStartDate = (contract) => (isDecapitalized ? contract.period?.startDate : contract.Period?.StartDate);
    const activeContract = contracts.find((contract) => ((getEndDate(contract) && dayjs(getEndDate(contract)).isAfter(onDate))
        || (!getEndDate(contract) && dayjs(getStartDate(contract)).isBefore(onDate))));
    return activeContract || null;
}
export const getPrimaryContractRow = (contract) => {
    const decapitalizedContract = Utils.objects.decapitalizeObjectKeysRecursively(contract);
    if (!decapitalizedContract.contractRows?.length)
        return null;
    return decapitalizedContract.contractRows.sort((a, b) => b.proportionPercent - a.proportionPercent)[0];
};
export const getPrimaryProfessionName = (contract) => {
    return getPrimaryContractRow(contract)?.profession?.name;
};
export function getContractTypeName(contractTypeId, contractTypes) {
    let types = contractTypes && [...contractTypes];
    if (!types)
        types = selectEmployeesContractType(store.getState()) || [];
    const type = types?.find((contractType) => contractType.ContractTypeId === contractTypeId);
    return type?.ContractTypeName || null;
}
export function getContractsOfUserForPeriod(contracts, userId, period) {
    const contractsOfUserForPeriod = [];
    const contractsOfUser = contracts[userId] || {};
    if (!contractsOfUser)
        return [];
    Object.values(contractsOfUser).forEach((contract) => {
        const { startDate, endDate } = contract.period;
        const contractPeriod = [
            dayjs(startDate),
            endDate ? dayjs(endDate) : MOMENT_MAX_DATE
        ];
        if (Utils.periods.checkPeriodsOverlap(contractPeriod, period, 'd', '[]')) {
            contractsOfUserForPeriod.push(contract);
        }
    });
    return contractsOfUserForPeriod;
}
